<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="epi"> </p>
<p class="ep-bot">Crimes reverberate through years and through lives. It is a rare homicide that destroys only one person.</p>
<p class="epc">Joyce Carol Oates, ‘After Black Rock’</p>
<p class="linespace"> </p>
<p class="ep-bot">Most gypsies fear the dead.</p>
<p class="epc">Raymond Buckland, <span class="epub-i">Buckland’s Book of Gypsy<br/>Magic – Travellers’ Stories,<br/>Spells &amp; Healings</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?280067d3